<template>
  <p>For inquiries relating to registration, sponsorship, or practical matters, please contact the
    <a href="https://www.embl.de/training/cco/contact/index.html">EMBL Course and Conference Office</a>:
  </p>
  <Email to="embl-events" :outstanding="true" />
  <p>For inquiries relating to the scientific content of the conference, please contact the VIZBI chairs:</p>
  <Email to="vizbi-contact" :outstanding="true" />
</template>

<script>
import Email from '@/components/Email.vue';
export default {
  components: {Email}
};
</script>

<style scoped>
p:not(:first-child) {
  margin-top: 18px;
}
</style>
